import React from "react";
import Batch from "../../atoms/Batch";
import { ReactComponent as GoldGraph } from '../../svgs/gold-graph.svg';
import { ReactComponent as SilverGraph } from '../../svgs/silver-graph.svg';
import { ReactComponent as BronzeGraph } from '../../svgs/bronze-graph.svg';

const BatchTitle = {
  gold: "Gold",
  silver: "Silver",
  bronze: "Bronze",
};

const CardContainer = ({ variant = "gold", children }) => {
  return (
    <div
      className="rounded-xl w-[calc(100%/3)]"
      style={{
        background: "rgba(67, 97, 238, 0.10)",
        border: "0.5px solid #4361EE",
        boxShadow: "0px 0px 6px 2px rgba(0, 0, 0, 0.14) inset",
      }}
    >
      <div className="px-3 pt-2">
        <div className="flex justify-between">
          <div className="text-sm font-normal">Average Price</div>
          <Batch variant={variant}>{BatchTitle[variant]}</Batch>
        </div>
        <div className="flex justify-between items-start">
          {variant === 'gold' ? <GoldGraph/> : variant === 'silver' ? <SilverGraph/> : <BronzeGraph/>}
          <div className="text-xl pt-2">
            ${children}
          </div>
        </div>
      </div>

    </div>
  );
};

export default CardContainer;
